"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Popover_1 = __importDefault(require("@mui/material/Popover"));
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var AutocompletePopover = (0, styles_1.styled)(Popover_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        '.MuiPopover-paper': {
            border: '1px solid #e1e4e8',
            boxShadow: '0 8px 24px rgba(149, 157, 165, 0.2)',
            borderRadius: 6,
            width: 350,
            zIndex: theme.zIndex.modal,
            fontSize: theme.typography.body1.fontSize,
            color: theme.palette.riverstone,
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(AutocompletePopover, {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
    },
});
